<template>
    <div>
        <div class="top">
            <span>{{ houseName }}</span>
            <span class="inlineblock">{{ cusName }} {{ cusMobile }}</span>
        </div>
        <div
            :class="preCls + 'filter'"
            style="display: flex; align-items: center; margin-top: 10px"
        >
            <check-tag-group
                style="display: inline-block; margin-right: 10px"
                v-model="meterType"
                multiple
                color="primary"
                @on-change="search"
            >
                <check-tag
                    v-for="item in dict.meterType.toList()"
                    :name="item.text"
                    :key="item.id"
                >
                    {{ item.text }}
                </check-tag>
            </check-tag-group>
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            >
            </filter-date-range>
        </div>
        <div style="margin-top: 10px">
            <Table
                ref="mt"
                :columns="columns"
                :data="page.list"
                :loading="loading"
                :height="mtHeight"
            >
            </Table>
            <!-- 底部分页 -->
            <table-pager
                transfer
                :total.sync="page.total"
                :pageSize.sync="filter.pageSize"
                :pageNo.sync="filter.page"
                @change="fetch"
            >
            </table-pager>
        </div>
    </div>
</template>
<script>
import { mapCache } from '@/plugins/vux-data-cache'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { currency, ymdL } from '_u/helper'

import FilterDateRange from '_v/components/filter/filter-date-range'

import { orderDeductionList } from '@/api/order'

export default {
    name: 'OrderDeductionList',

    inject: {
        $modal: {
            default: null,
        },
    },

    props: {
        houseId: {
            type: [String, Number],
            default: '',
        },
        houseName: {
            type: String,
            default: '',
        },
        cusId: {
            type: [String, Number],
            default: '',
        },
        cusName: {
            type: String,
            default: '',
        },
        cusMobile: {
            type: String,
            default: '',
        },
    },

    components: {
        FilterDateRange,
    },

    data() {
        return {
            mtHeight: 350,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            filter: {
                page: 1,
                pageSize: 20,
                houseId: this.houseId,
                cusId: this.cusId,
                meterType: '',
                startDate: '',
                endDate: '',
            },
            meterType: [],
            dict: {
                meterType: this.$dict.NULL,
            },
        }
    },

    computed: {
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    minWidth: 60,
                },
                {
                    key: 'createTime',
                    title: '扣费时间',
                    align: 'center',
                    minWidth: 180,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'meterType',
                    title: '表类型',
                    align: 'center',
                    minWidth: 100,
                    // render: mapCell(this.dict.meterType.toList())
                },
                {
                    key: 'degree',
                    title: '使用刻度',
                    align: 'left',
                    minWidth: 200,
                },
                {
                    key: 'price',
                    title: '单价',
                    align: 'right',
                    minWidth: 100,
                },
                {
                    key: 'deduction',
                    title: '扣费金额(元)',
                    align: 'right',
                    minWidth: 150,
                },
                {
                    key: 'balance',
                    title: '账户余额(元)',
                    align: 'right',
                    minWidth: 150,
                },
            ]
        },
    },

    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                this.$dict.get(['meter_type']),
                orderDeductionList(this.filter),
            ])
                .then((args) => {
                    var [group, view] = args

                    Object.assign(this.dict, group)

                    if (view.data.page) {
                        view.data.page.list.forEach((v) => {
                            v.degree =
                                v.degree +
                                ' (' +
                                v.lastDegree +
                                '~' +
                                v.currDegree +
                                ')'
                            v.price = currency(v.price / 100)
                            v.deduction = currency(v.deduction / 100)
                            v.balance = currency(v.balance / 100)
                        })
                        this.setPageData(view.data)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            if (this.meterType) {
                this.filter.meterType = this.meterType.join(',')
            }
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        var btns = [{ type: 'default', text: '关闭', name: 'cancel' }]
        this.$modal.updateBtns(btns)
    },
}
</script>
<style lang="less">
.top {
    font-size: 20px;
}
.inlineblock {
    display: inline-block;
    margin-left: 20px;
    font-size: 16px;
}
</style>
